<template>
  <div data-price="Price" class="u_price">
    <template v-if="price.installment">
      <template v-if="price.initial_price"
        >{{ price.initial_price | money(currency) }}
        {{ $t("checkout.then") }}</template
      >
      {{ price.price | money(currency) }}/{{ price.unit_display }}
      {{ $t("checkout.for") }} {{ price.cycles }} {{ $t("checkout.payments") }}
      <br /><small
        >({{ price.total | money(currency) }}
        {{ $t("cart.totalprice") }})</small
      >
    </template>
    <template v-else>
      {{ price.price | money(currency) }}
    </template>
  </div>
</template>

<script>
export default {
  props: ["price", "currency"],
};
</script>
